<template>
	<div id="app">
		<Nav></Nav>
		<router-view />
	</div>
</template>
<script>
	import Nav from "@/components/Nav.vue";

	export default {
		name: "app",
		components: {
			Nav,
		},
		watch: {},
		created() {
			// 进入获取当前电脑的可视区域

		},
	};
</script>
<style lang="scss">
	::-webkit-scrollbar {
		display: none;
	}

	#app {
		font-family: Microsoft YaHei;
		overflow-y: scroll;
		-ms-overflow-style: none;
		scrollbar-width: none;
		transition: 0.3s;
	}

	* {
		padding: 0px;
		margin: 0px;
	}

	ul {
		list-style: none;
	}
</style>